globalThis.masterBackoffice = globalThis.masterBackoffice || {};

masterBackoffice.Popover = (function()
{
  function Popover($html) {
    if($html.length) {
      this.$html = $html;
      this.width = $html.data('popover-width') || null;
      this.init();
    }
  }

  Popover.initPopovers = function($html) {
    $html.each(function() {
      var popover = new Popover($(this));
    });

    $('body').on('click', function (e) {
      $('.toggle-popover[aria-describedby]').each(function () {
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
          $(this).trigger('click');
        }
      });
    });
  }

  Popover.prototype = {
    init: function() {
      var $contentTarget = $('body').find(this.$html.data('popover-content-target')).first();
      this.$html.popover({ animation: false, content: $contentTarget.html().trim(), html: true });
      this.events();
    },
    events: function() {
      var me = this;
      this.$html.on('show.bs.popover', function() {
                  $('body').addClass('overlay');
                })
                .on('shown.bs.popover', function() {
                  $('.popover').find('textarea').focus();
                })
                .on('inserted.bs.popover', function() {
                  if(me.width) $('.popover').css('width', me.width);
                })
                .on('hide.bs.popover', function() {
                  $('body').removeClass('overlay');
                });
    }
  }
  return Popover;
})();
